document.addEventListener("DOMContentLoaded", function() {
  const menuRoot = document.querySelector("#menu_mb_ul");
  if (!menuRoot) return;

  // Fjern evt. eksisterende dropdown-handlers
  $(menuRoot).off('click', 'li.menu-item-has-children > a');

  const wrapper = document.createElement("div");
  wrapper.classList.add("menu-wrapper");
  menuRoot.parentNode.insertBefore(wrapper, menuRoot);
  wrapper.appendChild(menuRoot);

  function showMenu(menu) {
    wrapper.querySelectorAll("ul").forEach(ul => ul.classList.remove("active", "slide-in", "slide-out"));
    menu.classList.add("active");
  }

  function createBackButton(parentMenu, currentMenu) {
    const back = document.createElement("li");
    back.className = "menu-back";
    back.innerHTML = `<button class="back-btn">← Tilbage</button>`;
    back.querySelector("button").addEventListener("click", () => {
      currentMenu.classList.remove("slide-in");
      parentMenu.classList.remove("slide-out");
      showMenu(parentMenu);
    });
    currentMenu.insertBefore(back, currentMenu.firstChild);
  }

  menuRoot.querySelectorAll(".menu-item-has-children").forEach(item => {
    const submenu = item.querySelector("ul");
    if (!submenu) return;

    item.classList.add("has-submenu");

    // Tilføj højrepil
    const linkText = item.querySelector("a > .nav_link_txt");
    if(linkText) {
      linkText.innerHTML += ' <span class="arrow">→</span>';
    }

    item.querySelector("a").addEventListener("click", e => {
      e.preventDefault();
      const currentMenu = item.closest("ul");
      currentMenu.classList.add("slide-out");
      submenu.classList.add("slide-in");
      showMenu(submenu);
    });

    const parentMenu = item.closest("ul");
    if (!submenu.querySelector(".menu-back")) {
      createBackButton(parentMenu, submenu);
    }
  });

  showMenu(menuRoot);
});
